module.exports = __webpack_public_path__ + "dead.mp3?8a0883da5cbca79d146e0356a36cea99";


//////////////////
// WEBPACK FOOTER
// ./src/kits/1/sounds/dead.mp3
// module id = 482
// module chunks = 0